import ChangeLanguageContainer from './ChangeLanguageContainer';

export default ChangeLanguageContainer;
